import React from "react";
import { Button } from "primereact/button";
import { SanctionsListItem } from "./SanctionsListItem";
import { SanctionsListContentProps } from "./types";
import { Shield, XCircle, Filter, Info } from "lucide-react";

export const SanctionsListContent: React.FC<SanctionsListContentProps> = ({
    sanctionsLists,
    checkedLists,
    onCheckboxChange,
    onInfoClick,
    onFunnelClick,
    onSubmitClick,
    onUncheckAll
}) => {
    const allUnchecked = sanctionsLists.length > 0 && checkedLists.size === 0;
    const hasCheckedItems = checkedLists.size > 0;

    return (
        <div>
            <div className="flex flex-col md:flex-row items-center justify-between mb-4 py-3 px-4 gap-4 md:gap-0 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-lg text-white shadow-lg">
                <h6 className="text-base font-semibold m-0 flex items-center gap-2 justify-center md:justify-start">
                    <Shield size={18} className="opacity-90" />
                    Sanctions list
                </h6>
                <div className="flex items-center gap-2">
                    {hasCheckedItems && onUncheckAll && (
                        <Button
                            icon={<XCircle size={16} />}
                            label="Uncheck All"
                            className="bg-white/25 border border-white/40 text-white px-3 py-2 rounded-md text-sm font-medium transition-all duration-300 flex items-center gap-2 shadow-sm hover:bg-white/35 hover:border-white/50 hover:-translate-y-0.5 active:translate-y-0 [&_.p-button-icon]:text-sm [&_.p-button-label]:ml-1"
                            onClick={onUncheckAll}
                            tooltip="Uncheck all sanctions lists"
                        />
                    )}
                    <Button
                        icon={<Filter size={16} />}
                        className="bg-white/20 border border-white/30 text-white px-2.5 py-2 rounded transition-all duration-300 hover:bg-white/30 hover:-translate-y-0.5"
                        onClick={onFunnelClick}
                        tooltip="View combined JSON data"
                    />
                </div>
            </div>
            
            <div className="flex items-center gap-3 py-3 px-4 mb-4 bg-blue-50 border border-blue-200 rounded-md text-blue-900 text-sm">
                <Info size={18} className="text-primary-600 shrink-0" />
                <span className="leading-relaxed">Information: If all checkboxes are unchecked, the client will be automatically added to the whitelist.</span>
            </div>
            
            <div className="bg-neutral-50 dark:bg-neutral-900 rounded-lg p-4 mb-4 border border-neutral-200 dark:border-neutral-800 shadow-sm">
                {sanctionsLists.map((list) => (
                    <SanctionsListItem
                        key={list.id}
                        list={list}
                        isChecked={checkedLists.has(list.id)}
                        onCheckboxChange={onCheckboxChange}
                        onInfoClick={onInfoClick}
                    />
                ))}
            </div>
            
            <div className="bg-white dark:bg-neutral-900 rounded-lg p-4 border border-neutral-200 dark:border-neutral-800 shadow-sm">
                <Button
                    label="Submit Request"
                    onClick={onSubmitClick}
                    disabled={!allUnchecked}
                    className="bg-gradient-to-r from-green-500 to-teal-500 border-0 text-white px-5 py-2.5 rounded-md font-medium text-sm transition-all duration-300 shadow-[0_2px_8px_rgba(40,167,69,0.2)] hover:shadow-[0_3px_12px_rgba(40,167,69,0.3)] hover:-translate-y-0.5 disabled:bg-neutral-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-60"
                />
                <div className="text-neutral-500 dark:text-neutral-400 text-xs mt-2 italic flex items-center gap-2">
                    <span>💡</span>
                    <span>To proceed, uncheck all sanctions lists.</span>
                </div>
            </div>
        </div>
    );
};

